module.exports = __webpack_public_path__ + "static/media/img-pag-score.5211a86a.5211a86a.jpg";